import {ProjectBox} from '../project-box/project';
import React from 'react';
import {ProjectDescription} from '../project-box/description';


class ProjectBoxRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            numBoxes: this.props.numBoxes,
          };
      }
  
      render() {
        return (
          <div className="projectBoxRow">
            <div>
              <ProjectBox 
                title="Using Google Trends to Predict Incidents of Seasonal Illness" 
                boxLink="https://shreyaj1212.github.io/Influenza-Trends/"
                hoverColor="purple">
                  <p className="whiteText">
                    I pulled data from Google Trends about flu related terms. 
                    I created a Neural Network that used the Google Trends Data as an input to predict
                    how many people would get the flu three weeks in advance. 
                  </p>
                  <p className="whiteText">
                    I won 2nd place at the Massachusetts State Science Fair and an Honorable Mention at the Massachusetts Region IV Science Fair for this project.
                  </p>
                  <p className="whiteText">I explain my work further in <a href="https://youtu.be/aV8ov9skv0o">this YouTube Video</a>.</p>
              </ProjectBox>
              <ProjectBox 
                title="Explorantine" 
                hoverColor="purple"
                boxLink="https://devpost.com/software/explorantine-nhezvm">
                <p className="whiteText">
                  At the BB&N Hackathon in January 2021, I created Explorantine using Flask, Python, spaCy, SQL, HTML, CSS, JavaScript, and more. I had never used Flask before, and it was a great learning experience! <a href="https://youtu.be/ALz4xrCCu2M">Here is a video</a> and <a href="https://devpost.com/software/explorantine-nhezvm">here is a link to the devpost</a> to check out if you would like to learn more. 
                </p>
              </ProjectBox>
              <ProjectBox title="MX Dining Hall Tracker" hoverColor="purple">
                <p className="whiteText">
                  Middlesex School planned to re-open in hybrid mode in February. With rising cases and the cold winter season, the school has to be especially cautious but accomodate for the entire community eating in the Dining Hall. I created the MX Dining Hall Tracker to help track and limit the capacity of people in the Dining Hall. The school plans on using it in during February and March of 2021. I developed this in PHP, SQL, HTML, and CSS. 
                </p>
              </ProjectBox>
              <ProjectBox 
                title="Recover Athletics Website" 
                boxLink="https://recoverathletics.com"
                hoverColor="purple">
                  <p className="whiteText">I developed a new website for Recover Athletics, a Boston-based startup.</p>
              </ProjectBox>
              <ProjectBox 
                title="Anvil Website" 
                boxLink="http://mxanvil.net"
                hoverColor="purple">
                  <p className="whiteText">I developed a new website for The Anvil, the newspaper of Middlesex School.</p>
              </ProjectBox>
            </div>
          </div>
        );
      }
}

export {ProjectBoxRow};